import Translate from "./Translate";

type NoDataProps = {
    message?: string;
}

const NoData = (props: NoDataProps) => {
    const translationKey = props.message || "common.no-data";
    return <div><i>- <Translate i18nKey={translationKey} /> -</i></div>
}

export default NoData;
